module.exports = __webpack_public_path__ + "static/media/Back_Arrow@3x.bc185b46.png";